import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=04a0d67a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a0d67a')) {
      api.createRecord('04a0d67a', component.options)
    } else {
      api.reload('04a0d67a', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=04a0d67a&", function () {
      api.rerender('04a0d67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loader.vue"
export default component.exports